<template>
  <div class="register">
    <div class="register-banner"></div>
    <div class="register-view" v-if="!success">
      <form class="register-form">
        <input v-model="email" type="email" placeholder="请输入邮箱">
        <input v-model="password" type="password" placeholder="请输入密码">
        <input v-model="name" type="text" placeholder="姓名">
        <input v-model="phone" type="text" placeholder="手机号" maxlength="11">
        <input type="button" value="注册" @click="register">
      </form>
      <p>已有账号？<router-link to="/login">去登录</router-link></p>
    </div>
    <div class="result-view" v-else>
      <span>申请成功！</span>
      <span>我们将尽快审核您的申请！</span>
    </div>
  </div>
</template>

<script>
const mailReg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/
const phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

export default {
  components: {},
  props: {},
  data () {
    return {
      email: '',
      password: '',
      name: '',
      phone: '',
      success: false,
    }
  },
  computed: {
    getHeight () {
      return window.innerHeight - 180
    }
  },
  methods: {
    register () {
      if(!this.email || !this.password || !this.name || !this.phone) {
        alert('请填写完整信息！')
      } else if (!mailReg.test(this.email)) {
        alert('邮箱格式不正确！')
      } else if (!phoneReg.test(this.phone)) {
        alert('手机号格式不正确！')
      }else {
        this.success = true
      }
    }
  }
}
</script>
<style scoped>
.register {
  width: 1024px;
  margin: 50px auto 0;
  padding: 60px 20px;
  background-color: #fff;
  overflow: hidden;
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, .05);
}
.register-view {
  width: 350px;
  background-color: #fff;
  border-radius: 6px;
  text-align: center;
  font-size: 18px;
  overflow: hidden;
}
.register-view h4 {
  margin-bottom: 20px;
}
.register-view p {
  font-size: 14px;
}
.register-form input {
  display: block;
  width: 300px;
  height: 40px;
  margin: 0 auto;
  background-color: #f2f2f2;
  margin-bottom: 20px;
  border-radius: 5px;
  padding: 0 14px;
}
.register-form input[type="button"] {
  background-color: #34a2f6;
  color: #fff;
  margin: 28px auto 10px;
  cursor: pointer;
}
.register-view a {
  color: #34a2f6;
}
.register-banner{
  width: 550px;
  height: 380px;
  background-image: url('../assets/banner.png');
  float: left;
  margin-right: 30px;
}
.result-view {
  overflow: hidden;
  text-align: center;
  padding: 125px 0;
}
.result-view span {
  display: block;
  text-indent: 16px;
}
.result-view span:first-child {
  font-size: 24px;
  color: #34a2f6;
}
.result-view span:last-child {
  color: #666;
  margin-top: 12px;
}

</style>